import React, { useState, useEffect } from "react";
import './forexordersummary.css';
import download from "../assets/material-symbols_download (1).png";

const mockData = {
    cardtype: "Premium Forex Card",
    date: "2025-05-26",
    type: "Express Processing",
    name: "John Doe",
    purchaseno: "FX2025052601",
    product: "Multi-Currency Forex Card",
    EstimatedArrival: "2025-05-28",
    address: "123 Main Street, Downtown, New York, NY 10001, United States",
    currency: "USD",
    forexamt: "500.00",
    rate: "50.00",
    intamt: "₹42,150.00",
    gst: "₹7,587.00",
    totamt: "₹49,737.00",
    paymenttype: "Credit Card",
    paymentstatus: "Completed"
};

function ForexOrderSummary({ orderId }) {
    const [orderData, setOrderData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOrderData = async () => {
            try {
                setLoading(true);
                setError(null);
                
                
                const response = await fetch(`/api/forex-orders/${orderId || 'default'}`);
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const data = await response.json();
                setOrderData(data);
            } catch (err) {
                console.error('Failed to fetch order data:', err);
                setError(err.message);

                setOrderData(mockData);
            } finally {
                setLoading(false);
            }
        };

        fetchOrderData();
    }, [orderId]);

    const handleDownloadInvoice = () => {
        // Implement download functionality here
        console.log('Downloading invoice for order:', orderData?.purchaseno);
        // You can add actual download logic here
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div>Loading order details...</div>
            </div>
        );
    }

    
    const {
        cardtype,
        date,
        type,
        name,
        purchaseno,
        product,
        EstimatedArrival,
        address,
        currency,
        forexamt,
        rate,
        intamt,
        gst,
        totamt,
        paymenttype,
        paymentstatus
    } = orderData || mockData;

    return (
        <div className="forex-order-summary">
            {error && (
                <div className="error-notice">
                    <small>Note: Using sample data due to connection issue</small>
                </div>
            )}
            
            <div className="download" onClick={handleDownloadInvoice}>
                <span>Download Invoice</span>
                <img src={download} alt="Download" />
            </div>

            <div className="order-summary">
                <div className="order-header">
                    <div className="card-type">{cardtype}</div>
                    <div className="application-date">Date Of Application: {date}</div>
                    <div className="processing-type">Processing Type: {type}</div>
                </div>

                <div className="order-details">
                    <div className="details-header">
                        <div>Name</div>
                        <div>Purchase No.</div>
                        <div>Product</div>
                        <div>Estimated Arrival Time</div>
                    </div>
                    <div className="details-values">
                        <div>{name}</div>
                        <div>{purchaseno}</div>
                        <div>{product}</div>
                        <div>{EstimatedArrival}</div>
                    </div>
                </div>

                <div className="delivery-section">
                    <div className="delivery-header">Delivery Address</div>
                    <div className="delivery-address">
                        {address}
                    </div>
                </div>

                <div className="financial-details">
                    <div className="financial-row">
                        <div className="label">Currency</div>
                        <div className="value">{currency}</div>
                    </div>
                    
                    <div className="financial-row">
                        <div className="label">Forex Amount</div>
                        <div className="value">{forexamt}</div>
                        <div className="value" style={{color:"#994ed3",fontWeight:'400'}}>{rate}</div>
                    </div>
                    
                    <div className="financial-row">
                        <div className="label">INR Amount</div>
                        <div className="value">{intamt}</div>
                    </div>
                    
                    <div className="financial-row">
                        <div className="label">GST</div>
                        <div className="value">{gst}</div>
                    </div>
                    
                    <div className="financial-row total">
                        <div className="label">Total Amount</div>
                        <div className="value">{totamt}</div>
                    </div>
                    
                    <div className="financial-row">
                        <div className="label">Payment Type</div>
                        <div className="value">{paymenttype}</div>
                    </div>
                    
                    <div className="financial-row">
                        <div className="label">Payment Status</div>
                        <div className={`value status-${paymentstatus.toLowerCase()}`}>
                            {paymentstatus}
                        </div>
                    </div>
                </div>
            </div>

            <div className="track-order">
                <button className="track-button">Track Your Order</button>
            </div>
        </div>
    );
}

export default ForexOrderSummary;